const error_message = (err) => err?.body?.message ?? err?.message ?? `Something went wrong`;
const form_saver = ({ form, on_save }) => {
  let saving = $state(false);
  let save_error = $state(null);
  const save = async () => {
    save_error = null;
    saving = true;
    try {
      await on_save(form.values_to_save);
    } catch (err) {
      save_error = error_message(err);
    } finally {
      saving = false;
    }
  };
  const save_cb = (event) => {
    event.preventDefault();
    void save();
  };
  return {
    get saving() {
      return saving;
    },
    get save_error() {
      return save_error;
    },
    save,
    save_cb
  };
};
export default form_saver;
